import sproutSvg from "@/assets/sprout.svg";
import { cn } from "@/lib/utils";

interface SproutIconProps {
  className?: string;
}

export function SproutIcon({ className }: SproutIconProps) {
  return (
    <img
      src={sproutSvg}
      alt="Sprout"
      className={cn("h-4 w-4", className)}
    />
  );
}
